import { render, staticRenderFns } from "./HomeSectionNews.vue?vue&type=template&id=2034b314&scoped=true"
import script from "./HomeSectionNews.vue?vue&type=script&lang=js"
export * from "./HomeSectionNews.vue?vue&type=script&lang=js"
import style0 from "./HomeSectionNews.vue?vue&type=style&index=0&id=2034b314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034b314",
  null
  
)

export default component.exports